import { jsx } from 'react/jsx-runtime';
import { useId } from 'react';
import { useSafeLayoutEffect } from '@circlefin/hooks';
import classNames from 'classnames';
import { useFormSectionIds } from '../FormSection.Context/FormSection.Context.es.js';

const FormSectionTitle = ({ children, as: HtmlTag = 'div', className })=>{
    const id = useId();
    const { registerTitle } = useFormSectionIds();
    useSafeLayoutEffect(()=>{
        registerTitle(id);
    }, [
        registerTitle,
        id
    ]);
    return jsx(HtmlTag, {
        className: classNames('title', className),
        id: id,
        children: children
    });
};
FormSectionTitle.displayName = 'FormSection.Title';

export { FormSectionTitle };
//# sourceMappingURL=FormSection.Title.es.js.map
